import React, { Component, PropTypes } from 'react';
import ActionCreators from 'actions/ActionCreators';
import InputControl from 'components/InputControl';
import ButtonControl from 'components/ButtonControl';
import { translate as t } from 'lang';
import { setNewPasswordAfterRestore, dumpState } from 'api'

import './RestorePasswordNewPasswordDialogContent.scss';

class RestorePasswordNewPasswordDialogContent extends Component {

    static propTypes = {
        method: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired,
        inputValue: PropTypes.string.isRequired,
        onSubmit: PropTypes.func.isRequired,
    }

    state = {
        password: '',
        passwordRepeat: '',
        passwordNotEqualsError: false,
        errors: {},
    }

    _onChangePassword = (event, value) => {
        this.setState({
            password: value,
            passwordNotEqualsError: false,
            errors: Object.assign(this.state.errors, {
                password: '',
                passwordRepeat: '',
            }),
        });
    }

    _onChangePasswordRepeat = (event, value) => {
        this.setState({
            passwordRepeat: value,
            passwordNotEqualsError: false,
            errors: Object.assign(this.state.errors, {
                passwordRepeat: '',
                password: '',
            }),
        });
    }

    _onSubmit = () => {
        if (this.state.password !== this.state.passwordRepeat) {

            this.setState({
                passwordNotEqualsError: true,
                errors: Object.assign(this.state.errors, {
                    password: ' ',
                    passwordRepeat: ' '
                })
            });

            return false;
        }

        ActionCreators.showLoadingOverlay();

        setNewPasswordAfterRestore(this.props.method, this.state.password, this.props.inputValue, this.props.code)
            .then((response) => {
                ActionCreators.hideLoadingOverlay();

                if (response.autologin_hash && this.props.onSubmit) {
                    this.props.onSubmit(response.autologin_hash);
                } else if (Object.keys(response).length > 0) {
                    this.setState({
                        errors: response
                    });
                }
            })
            .catch(() => {
                ActionCreators.hideLoadingOverlay()
                dumpState()
                alert(t('SOMETHING_WENT_WRONG'))
            });
    }
    
    render() {
        return (
            <div class="RestorePasswordDialog RestorePasswordNewPasswordDialogContent">
                {this.state.passwordNotEqualsError ?
                    <div className="RestorePasswordDialog-errorBox">{t('PASSWORD_NOT_EQUAL')}</div>
                    : ''}
                <div className="RestorePasswordDialog-doubleInputBox">
                    <InputControl className="RestorePasswordDialog-doubleInputBoxInput"
                                  label={t('ENTER_NEW_PASSWORD')}
                                  placeholder={t('NEW_PASSWORD')}
                                  onChange={this._onChangePassword}
                                  value={this.state.password}
                                  error={this.state.errors.password || ''}
                                  htmlType="password" />
                    <div className="RestorePasswordDialog-doubleInputBoxDivider"></div>
                    <InputControl className="RestorePasswordDialog-doubleInputBoxInput"
                                  label={t('REPEAT_NEW_PASSWORD')}
                                  placeholder={t('REPEAT_PASSWORD')}
                                  onChange={this._onChangePasswordRepeat}
                                  value={this.state.passwordRepeat}
                                  error={this.state.errors.passwordRepeat || ''}
                                  htmlType="password" />
                </div>
                <div className="RestorePasswordNewPasswordDialogContent-passTip">Минимум 6 символов</div>
                <div className="RestorePasswordDialog-infoBox">
                    {t('RESTORE_PASSWORD_AFTER_NEW_PASSWORD_INFO')}
                </div>
                <div className="RestorePasswordDialog-changePasswordBox">
                    <ButtonControl
                        className="RestorePasswordDialog-changePasswordButton"
                        view="sand"
                        size="l"
                        onClick={this._onSubmit}>
                        {t('SET_NEW_PASSWORD')}<br/>
                        {t('AND')} {t('ADD_ORDER')}
                    </ButtonControl>
                </div>
            </div>
        );
    }
}

export default RestorePasswordNewPasswordDialogContent;



// WEBPACK FOOTER //
// ./client/components/RestorePasswordNewPasswordDialogContent/RestorePasswordNewPasswordDialogContent.js